/**
 * Browser support tests, replacing Modernizr
 */

const supports = {
    // Determine if a browser supports touch events
    get touchevents() {
        return (
            typeof window !== "undefined" &&
            (("ontouchstart" in window) as boolean)
        );
    },
} as const;

export default supports;
